import React, { Component } from 'react'
import '../styles/FAQ.css'
import Navbar from './Navbar'
import Footer from './Footer'
import FAQAnswer from './FAQAnswer'
import FAQHero from '../images/FAQ/FAQHero.png'
import {Helmet} from 'react-helmet'
import { injectIntl, defineMessages } from 'react-intl'

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

class FAQ extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTopic: "games",
      openAnswers: [],
      isTop: true,
      prices: ""
    }

    const list = [2, 3, 4, 5, 6];
    this.props.getPrices(list, true).then((output) => {
      this.setState({ prices: output });
    })
    .catch((e) => {
      console.error(e);
    });
  }

  openQuestion = (id) => {
    if (!this.state.openAnswers.includes(id)) {
      const answers = this.state.openAnswers
      answers.push(id)
      this.setState({ answers: answers })
      window.setTimeout(() => {
        this.adjustContainerHeight(id, 1)
      }, 200)
    } else if (this.state.openAnswers.includes(id)) {
      this.setState({
        openAnswers: this.state.openAnswers.filter(ids => ids !== id)
      }, this.adjustContainerHeight(id, -1))
    }
  }

  adjustContainerHeight = (id, direction) => {
    const container = document.getElementById("faq-content-container")
    const offset = container.offsetHeight
    const answerHeight = document.getElementById(`faq-answer-${id}`).offsetHeight
    const answerHeaderHeight = document.getElementById(`faq-answer-header-${id}`).offsetHeight
    const faqContent = document.getElementById("faq-content")
    const faqContentOffset = faqContent.offsetHeight + parseInt(window.getComputedStyle(faqContent).getPropertyValue('top'), 10)
    // Check if faq content is higher than container (or if we collapse answer)
    if (offset < faqContentOffset || direction < 0) {
      let height = offset + direction * (answerHeight - answerHeaderHeight) + "px"
      container.style.height = height
    }
  }

  testOpen = (id) => {
    if (this.state.openAnswers.includes(id)) {
      return "faq-answer faq-answer--open"
    } else {
      return "faq-answer"
    }
  }

  isToggled = (id) => {
    return this.state.openAnswers.includes(id)
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }

  render() {
    const {intl:{formatMessage}} = this.props

    const testSelectedTopic = (topic) => {
      if (this.state.selectedTopic === topic) {
        return "faq-nav-item faq-nav-item--selected"
      } else {
        return "faq-nav-item"
      }
    }

    return (
     <div className="faq">
      <Helmet>
        <title>Foire aux questions - One Hour escape game Paris</title>
		<meta name="description" content="Toutes les réponses à vos questions sur One Hour Escape Game Paris. Les tarifs, le nombre de joueurs, la difficultée etc..."/>
		<html lang="fr" />
      </Helmet>
      <Navbar
        isTop={this.state.isTop}
        handleLang={(lang) => this.props.handleLang(lang)}/>
      <div className="faq-pattern-container" style={{ backgroundImage: `url(${FAQHero})`}}>
        <div className="faq-hero-title">
          <h1>{formatMessage(messages.title)}</h1>
          <p>{formatMessage(messages.baseline)}</p>
        </div>
      </div>
      <div className="faq-content-container" id="faq-content-container">
        <div className="faq-content" id="faq-content">
          <ul className="faq-nav">
            <li
              className={testSelectedTopic("games")}
              onClick={ () => this.setState({ selectedTopic: "games"})}>{formatMessage(messages.games)}</li>
            <li
              className={testSelectedTopic("gamers")}
              onClick={ () => this.setState({ selectedTopic: "gamers"})}>{formatMessage(messages.players)}</li>
            <li
              className={testSelectedTopic("billing")}
              onClick={ () => this.setState({ selectedTopic: "billing"})}>{formatMessage(messages.billing)}</li>
            <li
              className={testSelectedTopic("corporate")}
              onClick={ () => this.setState({ selectedTopic: "corporate"})}>{formatMessage(messages.corporate)}</li>
          </ul>
          {
            this.state.selectedTopic === "games"
            ? <div>
                <FAQAnswer
                    id={1}
                    title={formatMessage(messages.gamesA)}
                    handleClick={id => this.openQuestion(id)}
                    testOpen={id => this.testOpen(id)}
                    isToggled={id => this.isToggled(id)}
                    >
                    <p>{formatMessage(messages.gamesA1)}</p>
                    <p>{formatMessage(messages.gamesA2)} <br />
                      {formatMessage(messages.gamesA3)} </p>
                    <p>{formatMessage(messages.gamesA4)}<br />
                    {formatMessage(messages.gamesA5)}</p>
                  </FAQAnswer>
                  <FAQAnswer
                    id={2}
                    title={formatMessage(messages.gamesB)}
                    handleClick={id => this.openQuestion(id)}
                    testOpen={id => this.testOpen(id)}
                    isToggled={id => this.isToggled(id)}
                    >
                    <p>{formatMessage(messages.gamesB1)}</p>
                    <p><strong>{formatMessage(messages.gamesB2)}</strong> <br />
                      {formatMessage(messages.gamesB3)} </p>
                    <p><strong>{formatMessage(messages.gamesB4)} </strong><br />
					  {formatMessage(messages.gamesB4)}</p>
                  </FAQAnswer>
                  <FAQAnswer
                    id={3}
                    title={formatMessage(messages.gamesC)}
                    handleClick={id => this.openQuestion(id)}
                    testOpen={id => this.testOpen(id)}
                    isToggled={id => this.isToggled(id)}
                    >
                    <p>{formatMessage(messages.gamesC1)}</p>
                    <p>{formatMessage(messages.gamesC2)} <br />
                      {formatMessage(messages.gamesC3)} </p>
                    <p>{formatMessage(messages.gamesC4)}<br />
                    <strong>{formatMessage(messages.gamesC5)}</strong></p>
                  </FAQAnswer>
                  <FAQAnswer
                    id={4}
                    title={formatMessage(messages.gamesD)}
                    handleClick={id => this.openQuestion(id)}
                    testOpen={id => this.testOpen(id)}
                    isToggled={id => this.isToggled(id)}
                    >
                    <p>{formatMessage(messages.gamesD1)}</p>
                    <p>{formatMessage(messages.gamesD2)}</p>
                  </FAQAnswer>
                  <FAQAnswer
                    id={5}
                    title={formatMessage(messages.gamesE)}
                    handleClick={id => this.openQuestion(id)}
                    testOpen={id => this.testOpen(id)}
                    isToggled={id => this.isToggled(id)}
                    >
                    <p>{formatMessage(messages.gamesE1)}</p>
                    <p>{formatMessage(messages.gamesE2)}</p>
					<p>{formatMessage(messages.gamesE3)}</p>
                  </FAQAnswer>
                  <FAQAnswer
                    id={6}
                    title={formatMessage(messages.gamesF)}
                    handleClick={id => this.openQuestion(id)}
                    testOpen={id => this.testOpen(id)}
                    isToggled={id => this.isToggled(id)}
                    >
                    <p>{formatMessage(messages.gamesF1)}</p>
                  </FAQAnswer>
                </div>
            : null
          }
          {
            this.state.selectedTopic === "gamers"
            ? <div>
                <FAQAnswer
                  id={7}
                  title={formatMessage(messages.gamersA)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersA1)}</p>
                  <p>{formatMessage(messages.gamersA2)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={8}
                  title={formatMessage(messages.gamersB)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersB1)}</p>
                  <p><strong>{formatMessage(messages.gamersB2)}</strong></p>
                  <p>{formatMessage(messages.gamersB3)}</p>
                  <p>{formatMessage(messages.gamersB4)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={9}
                  title={formatMessage(messages.gamersC)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersC1)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={10}
                  title={formatMessage(messages.gamersD)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersD1)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={11}
                  title={formatMessage(messages.gamersE)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersE1)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={12}
                  title={formatMessage(messages.gamersF)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersF1)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={13}
                  title={formatMessage(messages.gamersG)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.gamersG1)}</p>
                </FAQAnswer>
              </div>
            : null
          }
          {
            this.state.selectedTopic === "billing"
            ?
              <div className="faq-content-text">
                <FAQAnswer
                  id={14}
                  title={formatMessage(messages.billingA)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                    <p>{formatMessage(messages.billingA1)} <span dangerouslySetInnerHTML={{ __html: this.state.prices }}></span></p>
                </FAQAnswer>
                <FAQAnswer
                  id={15}
                  title={formatMessage(messages.billingB)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.billingB1)}</p>
                  <p>{formatMessage(messages.billingB2)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={16}
                  title={formatMessage(messages.billingC)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.billingC1)}</p>
                  <p>{formatMessage(messages.billingC2)} <br />
                    {formatMessage(messages.billingC3)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={17}
                  title={formatMessage(messages.billingD)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.billingD1)}</p>
                  <p>{formatMessage(messages.billingD2)} <br />
				     {formatMessage(messages.billingD3)} <br />
					 {formatMessage(messages.billingD4)} </p>
                  <p>{formatMessage(messages.billingD5)}</p>
                </FAQAnswer>
                <FAQAnswer
                  id={18}
                  title={formatMessage(messages.billingE)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.billingE1)}</p>
                </FAQAnswer>
              </div>
            : null
          }
          {
            this.state.selectedTopic === "corporate"
            ?
              <div className="faq-content-text">
                <FAQAnswer
                  id={19}
                  title={formatMessage(messages.corporateA)}
                  handleClick={id => this.openQuestion(id)}
                  testOpen={id => this.testOpen(id)}
                  isToggled={id => this.isToggled(id)}
                  >
                  <p>{formatMessage(messages.corporateA1)}</p>
                  <p>{formatMessage(messages.corporateA2)} <br />
				  </p>
                </FAQAnswer>
              </div>
            : null
          }
        </div>
      </div>
      <Footer />
     </div>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'faq.title',
    defaultMessage: 'F.A.Q.'
  },
  baseline: {
    id: 'faq.baseline',
    defaultMessage: 'Vous avez une question nous avons les réponses !'
  },
  games: {
    id: 'faq.games',
    defaultMessage: 'jeux'
  },
  players: {
    id: 'faq.players',
    defaultMessage: 'joueurs'
  },
  billing: {
    id: 'faq.billing',
    defaultMessage: 'paiement'
  },
  corporate: {
    id: 'faq.corporate',
    defaultMessage: 'entreprises'
  },
  gamesA1: {
    id: 'faq.gamesA1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamesA2: {
    id: 'faq.gamesA2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamesA3: {
    id: 'faq.gamesA3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamesA4: {
    id: 'faq.gamesA4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  gamesA5: {
    id: 'faq.gamesA5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamesB1: {
    id: 'faq.gamesB1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamesB2: {
    id: 'faq.gamesB2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamesB3: {
    id: 'faq.gamesB3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamesB4: {
    id: 'faq.gamesB4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  gamesB5: {
    id: 'faq.gamesB5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamesC1: {
    id: 'faq.gamesC1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamesC2: {
    id: 'faq.gamesC2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamesC3: {
    id: 'faq.gamesC3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamesC4: {
    id: 'faq.gamesC4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  gamesC5: {
    id: 'faq.gamesC5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamesD1: {
    id: 'faq.gamesD1',
    defaultMessage: 'Aucun problème pour la difficulté ! Le maître du jeu s’adapte en fonction du niveau de chaque équipe. Notre objectif est avant tout que tout le monde s’amuse.'
  },
  gamesD2: {
    id: 'faq.gamesD2',
    defaultMessage: 'A contrario, si vous êtes des habitués, ne vous inquiétez pas, on saura vous mettre des bâtons dans les roues !'
  },
  gamesE1: {
    id: 'faq.gamesE1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamesE2: {
    id: 'faq.gamesE2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamesE3: {
    id: 'faq.gamesE3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamesF1: {
    id: 'faq.gamesF1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersA1: {
    id: 'faq.gamersA1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersA2: {
    id: 'faq.gamersA2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamersA3: {
    id: 'faq.gamersA3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamersA4: {
    id: 'faq.gamersA4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  gamersA5: {
    id: 'faq.gamersA5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamersB1: {
    id: 'faq.gamersB1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersB2: {
    id: 'faq.gamersB2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamersB3: {
    id: 'faq.gamersB3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamersB4: {
    id: 'faq.gamersB4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  gamersB5: {
    id: 'faq.gamersB5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamersC1: {
    id: 'faq.gamersC1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersC2: {
    id: 'faq.gamersC2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  gamersC3: {
    id: 'faq.gamersC3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  gamersC4: {
    id: 'faq.gamersC4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  gamersC5: {
    id: 'faq.gamersC5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamersD1: {
    id: 'faq.gamersD1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersE1: {
    id: 'faq.gamersE1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersF1: {
    id: 'faq.gamersF1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  gamersG1: {
    id: 'faq.gamersG1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingA1: {
    id: 'faq.billingA1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingA2: {
    id: 'faq.billingA2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  billingA3: {
    id: 'faq.billingA3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  billingA4: {
    id: 'faq.billingA4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  billingA5: {
    id: 'faq.billingA5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  billingB1: {
    id: 'faq.billingB1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingB2: {
    id: 'faq.billingB2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  billingB3: {
    id: 'faq.billingB3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  billingB4: {
    id: 'faq.billingB4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  billingB5: {
    id: 'faq.billingB5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  billingC1: {
    id: 'faq.billingC1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingC2: {
    id: 'faq.billingC2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  billingC3: {
    id: 'faq.billingC3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  billingC4: {
    id: 'faq.billingC4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  billingC5: {
    id: 'faq.billingC5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  billingD: {
    id: 'faq.billingD',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingD1: {
    id: 'faq.billingD1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingD2: {
    id: 'faq.billingD2',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingD3: {
    id: 'faq.billingD3',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingD4: {
    id: 'faq.billingD4',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingD5: {
    id: 'faq.billingD5',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingE: {
    id: 'faq.billingE',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  billingE1: {
    id: 'faq.billingE1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  corporateA1: {
    id: 'faq.corporateA1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  corporateA2: {
    id: 'faq.corporateA2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  corporateA3: {
    id: 'faq.corporateA3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  corporateA4: {
    id: 'faq.corporateA4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  corporateA5: {
    id: 'faq.corporateA5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  corporateB1: {
    id: 'faq.corporateB1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  corporateB2: {
    id: 'faq.corporateB2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  corporateB3: {
    id: 'faq.corporateB3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  corporateB4: {
    id: 'faq.corporateB4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  corporateB5: {
    id: 'faq.corporateB5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  corporateC1: {
    id: 'faq.corporateC1',
    defaultMessage: 'One Hour est un Live Escape Game'
  },
  corporateC2: {
    id: 'faq.corporateC2',
    defaultMessage: 'Enfermés dans une pièce, le principe est d’arriver à vous échapper de cet endroit dans un temps imparti (60 minutes, une heure ou One Hour !).'
  },
  corporateC3: {
    id: 'faq.corporateC3',
    defaultMessage: 'L’équipe de joueurs (entre 2 et 5 personnes) doit résoudre des énigmes, fouiller, observer et manipuler des objets pour avancer dans le scénario.'
  },
  corporateC4: {
    id: 'faq.corporateC4',
    defaultMessage: 'Mais les joueurs ne sont pas totalement livrés à eux-mêmes !'
  },
  corporateC5: {
    id: 'faq.corporateC5',
    defaultMessage: 'Un maître du jeu suit la partie via des caméras et micros, il peut vous aider dans votre aventure.'
  },
  gamesA: {
    id: 'faq.gamesA',
    defaultMessage: "One Hour, c'est quoi ?"
  },
  gamesB: {
    id: 'faq.gamesB',
    defaultMessage: 'Quels sont les thèmes disponibles'
  },
  gamesC: {
    id: 'faq.gamesC',
    defaultMessage: 'Combien de temps dure une partie ?'
  },
  gamesD: {
    id: 'faq.gamesD',
    defaultMessage: 'C’est ma première partie, est-ce que ça ne va pas être trop dur ?'
  },
  gamesE: {
    id: 'faq.gamesE',
    defaultMessage: 'C’est ma première partie, est-ce que ça ne va pas être trop dur ?'
  },
  gamesF: {
    id: 'faq.gamesF',
    defaultMessage: 'C’est ma première partie, est-ce que ça ne va pas être trop dur ?'
  },
  gamersA: {
    id: 'faq.gamersA',
    defaultMessage: "One Hour, c'est quoi ?"
  },
  gamersB: {
    id: 'faq.gamersB',
    defaultMessage: 'Quels sont les thèmes disponibles'
  },
  gamersC: {
    id: 'faq.gamersC',
    defaultMessage: 'Combien de temps dure une partie ?'
  },
  gamersD: {
    id: 'faq.gamersD',
    defaultMessage: "One Hour, c'est quoi ?"
  },
  gamersE: {
    id: 'faq.gamersE',
    defaultMessage: 'Quels sont les thèmes disponibles'
  },
  gamersF: {
    id: 'faq.gamersF',
    defaultMessage: 'Combien de temps dure une partie ?'
  },
  gamersG: {
    id: 'faq.gamersG',
    defaultMessage: 'Combien de temps dure une partie ?'
  },
  billingA: {
    id: 'faq.billingA',
    defaultMessage: "One Hour, c'est quoi ?"
  },
  billingB: {
    id: 'faq.billingB',
    defaultMessage: 'Quels sont les thèmes disponibles'
  },
  billingC: {
    id: 'faq.billingC',
    defaultMessage: 'Combien de temps dure une partie ?'
  },
  corporateA: {
    id: 'faq.corporateA',
    defaultMessage: "One Hour, c'est quoi ?"
  },
  corporateB: {
    id: 'faq.corporateB',
    defaultMessage: 'Quels sont les thèmes disponibles'
  },
  corporateC: {
    id: 'faq.corporateC',
    defaultMessage: 'Combien de temps dure une partie ?'
  },
})

export default injectIntl(FAQ)



// WEBPACK FOOTER //
// ./src/components/FAQ.js